
<ng-template #listViewPromo let-modal>
	<div style = "margin:0 auto;" class="modal-header">
		<h4  class="modal-title" id="modal-basic-title">Get List View with Subscrybe Premium!</h4>
		<!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
		  <span aria-hidden="true">&times;</span>
		</button> -->
	  </div>
	  <div style = "text-align:center;margin:0 auto;" class="modal-body">

		<video width = "1000" controls autoplay loop>
				<source src="assets/listViewPromo.mp4" type="video/mp4">
		</video>
		  <app-checkout></app-checkout>

	  </div>
</ng-template>


<ng-template #breakdownPromo let-modal>
	<div style = "margin:0 auto;" class="modal-header">
			<h4 class="modal-title" id="modal-basic-title">Get spending insights with Subscrybe Premium!</h4>
			<!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button> -->
			</div>
			<div style = "text-align:center;margin:0 auto;" class="modal-body">
	
			<video width = "1000" controls autoplay loop>
					<source src="assets/breakdownPromo.mp4" type="video/mp4">
			</video>
			<app-checkout></app-checkout>
	</div>
</ng-template>



<ng-template #addSub let-modal>
				<div class="modal-header">
				  <h4 class="modal-title" id="modal-basic-title">Add Subscription</h4>
				  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
					<span aria-hidden="true">&times;</span>
				  </button>
				</div>
				<div class="modal-body">
				  <form>
					<div class="form-group">

					<label for = "newSubName">Subscription Name</label>
					<input #newSubName type="text" class="form-control" id="newSubName" aria-describedby="emailHelp" placeholder="Ex: Netflix">
		
					<label for="newPrice">Price</label>
					<input #newPrice type="text" class="form-control" id="newSubUrl" aria-describedby="emailHelp" placeholder="Ex:$10">

					<label for="newSubUrl">Site Url</label>
					<input #newSubUrl type="text" class="form-control" id="newSubUrl" aria-describedby="emailHelp" placeholder="Ex:netflix.com">
		
		
					  <label for="newSubExpiry">Next Billing Date</label>
					  <div class="input-group">
						<input #newSubExpiry id="newSubExpiry" class="form-control" placeholder="Ex:2020-12-15" name="dp" ngbDatepicker #dp="ngbDatepicker">
						<div class="input-group-append">
						  <button class="btn btn-outline-secondary calendar" (click)="dp.toggle()" type="button"></button>
						</div>
					  </div>
	
					  <label for="paymentSched">Payment Schedule</label>
					  <select #paymentSched style = "width:100%;" class = "form-control">
							<option  value="monthly" [selected]="true">Monthly</option>
							<option  value="weekly" >Weekly</option>
							<option  value="bi-weekly">Bi-Weekly</option>
							<option  value="quarterly">Quarterly</option>
							<option  value="bi-annually">Bi-Annually</option>
							<option  value="annualy">Annually</option>
						</select>

					</div>
				  </form>
				</div>
				<div class="modal-footer">
					<ng-container *ngIf = "this.buttonLoading">
							<button type="button" class="btn btn-outline-dark">
									<div class="spinner-border spinner-border-sm" role="status">
											<!-- <span class="sr-only">Loading...</span> -->
									</div>
							</button>
					</ng-container>
					<ng-container *ngIf = "!this.buttonLoading">
							<button type="button" class="btn btn-outline-dark" (click)="addSubscription(newSubName.value,newSubUrl.value.replace('http://','').replace('https://','').split('/')[0],newSubExpiry.value,paymentSched.value,newPrice.value)">Add</button>
					</ng-container>
				</div>
</ng-template>

<ng-template #content let-modal>
		<div class="modal-header">
		  <h4 class="modal-title" id="modal-basic-title">Update subscription</h4>
		  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		  </button>
		</div>
		<div class="modal-body">
		  <form>
			<div class="form-group">


				<label for="subName">Subscription Name</label>
				<input #subName type="text" class="form-control" id="subName" aria-describedby="emailHelp" value={{currSubscriptionName}}>

				<label for="subPrice">Price</label>
				<input #price type="text" class="form-control" id="price" aria-describedby="emailHelp" value={{currSubscriptionPrice}}>

				<label for="startSub">Subscription Start</label>
				<div class="input-group">
					<input #startSub id="startSub" class="form-control" value={{currSubscriptionStart}} name="dp" ngbDatepicker #dp="ngbDatepicker">
					<div class="input-group-append">
					<button class="btn btn-outline-secondary calendar" (click)="dp.toggle()" type="button"></button>
					</div>
				</div>

			  <label for="endSub">Next Billing Date</label>
			  <div class="input-group">
				<input #endSub id="endSub" class="form-control" value={{currSubscriptionExpiry}} name="dp" ngbDatepicker #dp="ngbDatepicker">
				<div class="input-group-append">
				  <button class="btn btn-outline-secondary calendar" (click)="dp.toggle()" type="button"></button>
				</div>
			  </div>

			  <label for="subUrl">Site Url</label>
			  <input #subUrl type="text" class="form-control" id="subUrl" aria-describedby="emailHelp" value={{currSubscriptionUrl}}>

			  <label for="duration">Payment Schedule</label>
			  <select #duration style = "width:100%;" class = "form-control">
				<option  value="monthly" [selected]="isPaymentSched(currSubscriptionCycle,'monthly')">Monthly</option>
				<option  value="weekly" [selected]="isPaymentSched(currSubscriptionCycle,'weekly')">Weekly</option>
				<option  value="bi-weekly" [selected]="isPaymentSched(currSubscriptionCycle,'bi-weekly')">Bi-Weekly</option>
				<option  value="quarterly" [selected]="isPaymentSched(currSubscriptionCycle,'quarterly')">Quarterly</option>
				<option  value="bi-annually" [selected]="isPaymentSched(currSubscriptionCycle,'bi-annually')">Bi-Annually</option>
				<option  value="annualy" [selected]="isPaymentSched(currSubscriptionCycle,'annualy')">Annually</option>
			</select>

			  <div style = "display:flex;justify-content: center;">
					<p>Status:&nbsp;</p><p [ngClass]="{activeSub: currSubscriptionStatus == 'active', cancelledSub: currSubscriptionStatus == 'cancelled' || currSubscriptionStatus =='alerts paused'}">{{currSubscriptionStatus ? currSubscriptionStatus.charAt(0).toUpperCase() + currSubscriptionStatus.slice(1) : ''}}</p>
					
					<!-- <button id = "update-btn" type="button" class="btn btn-outline-primary" (click)="updateSubscription(subName.value,subUrl.value,endSub.value,duration.value,price.value)">Update</button> -->
				</div>
			</div>
		  </form>
		</div>
		<div [ngStyle] = "{'justify-content': (currSubscriptionStatus == 'cancelled') ? 'flex-end' : 'space-between'}" class="modal-footer">
		
		<ng-container *ngIf = "currSubscriptionStatus != 'cancelled'">
			<!-- active or stopped -->
		<button id = {{findId(currSubscriptionStatus)}} type="button" class="btn btn-outline-primary" (click)="manageAlerts(currSubscriptionId)">
			{{currSubscriptionStatus == 'active' ? 'Stop Alerts' : 'Resume Alerts'}}
		</button>
	</ng-container>
	<button id = "stop-btn" type="button" class="btn btn-outline-primary" (click)="deleteSubscription()">
		Delete Subscription
	</button>
		  <button id = "update-btn" type="button" class="btn btn-outline-primary" (click)="updateSubscription(subName.value,subUrl.value,endSub.value,duration.value,price.value)">Update</button>
		</div>
</ng-template>

<div class = "subscriptions-content">
	<h3 id = "all-subscriptions-title">{{this.username}}{{this.username == 'My' ? '' : "'s"}} Subscriptions</h3>
	<div class = "view-check">
			<div class = "breakdown-check">
				<div *ngIf = "!subscriptionPlan">
						<div class="spinner-border spinner-border-sm" role="status">
								<!-- <span class="sr-only">Loading...</span> -->
						</div>
				</div>
				<ng-container *ngIf = "subscriptionPlan == 'Free'">
						<button (click)="openListViewPromo(breakdownPromo)" id = "update-btn" class="btn btn-outline-primary">
								View Subscriptions Breakdown
							</button>
				</ng-container>

				<ng-container *ngIf = "subscriptionPlan == 'subscrybe-premium'">
						<button (click)="getBreakdown()" id = "update-btn" class="btn btn-outline-primary">
								View Subscriptions Breakdown
						</button>
				</ng-container>
				</div>
		<div>
		<strong style = "font-size:16px;">Subscriptions View:</strong> 

		<ng-container *ngIf = "subscriptionPlan == 'subscrybe-premium'">
				<i placement="top" ngbTooltip="Tile View" (click)="changeView('tile')" id = "{{getView('tile')}}" class="fas fa-th-large"></i>
				<i placement="top" ngbTooltip="List View" (click)="changeView('list')" id = "{{getView('list')}}" class="fas fa-th-list"></i>
		</ng-container>
		<ng-container *ngIf = "subscriptionPlan == 'Free'">
				<i placement="top" ngbTooltip="Tile View" (click)="openListViewPromo(listViewPromo)" id = "{{getView('tile')}}" class="fas fa-th-large"></i>
				<i placement="top" ngbTooltip="List View" (click)="openListViewPromo(listViewPromo)" id = "{{getView('list')}}" class="fas fa-th-list"></i>
		</ng-container>
		<ng-container *ngIf = "!subscriptionPlan">
			<div class="spinner-border spinner-border-sm" role="status">
					<!-- <span class="sr-only">Loading...</span> -->
			</div>
		</ng-container>
	</div>
	</div>
	<ng-container *ngIf = "loading">
			<div class="spinner-border spinner-border-sm" role="status"></div>
	</ng-container>
<div *ngIf = "!loading && view == 'list'" class = "table-responsive">
	<table class="table">
		<thead style = "color:white;background: linear-gradient(135deg,#a158ff,#522bd4);">
		  <tr>
			<th scope="col">Subscription</th>
			<th scope="col">Price <i id = "chevrons" (click)="sortByPrice()" style = "margin-top:5px;margin-left:5px;" class={{priceChevronClass}}></i></th>
			<th scope="col">Next Bill <i id = "chevrons" (click)="sortByDate()" style = "margin-top:5px;margin-left:5px;" class={{dateChevronClass}}></i> </th>
			<th scope="col">Status <i id = "chevrons" (click)="sortByStatus()" style = "margin-top:5px;margin-left:5px;" class={{statusChevronClass}}></i></th>
			<th scope="col">Days Till Renewal <i id = "chevrons" (click)="sortByDate()" style = "margin-top:5px;margin-left:5px;" class={{dateChevronClass}}></i> </th>
			<th scope="col"></th>
		  </tr>
		</thead>
		<tbody>
			<ng-container *ngFor = "let subscription of subscriptionsArray.slice(0,objectKeys(subscriptions).length);">
				<tr>
					<th scope="row"><img style = "height:25px;" src = "https://logo.clearbit.com/{{subscription[1].url}}">&nbsp;{{subscription[1].name}}</th>
					<td>{{subscription[1].price}}  /{{subscription[1].payment_sched.slice(0,subscription[1].payment_sched.length-2)}}</td>
					<td>{{formattedDate(subscription[1].next_bill)}}</td>
					<td id ="{{getStatusId(subscription[1].status,subscription[1].next_bill)}}">{{formatStatus(subscription[1].status,subscription[1].next_bill)}}</td>
					<td>{{expiringSoon(subscription[1].next_bill,true)}}</td>
					<td><button (click)="open(content,subscription[1],subscription[0])" class = "viewdetails-btn">UPDATE</button></td>
				</tr>
			</ng-container>
		</tbody>
	  </table>
</div>
<div *ngIf="!loading && view == 'tile'" class = "subscriptions">
	<div *ngIf = "!objectKeys(subscriptions) || objectKeys(subscriptions).length < 1">
		<h2>You currently have no subscriptions, feel free to add one manually.</h2>
	</div>
		<div cdkDrag (cdkDragEnded)="dragEnd($event)" *ngFor = "let subscription of subscriptionsArray.slice(0,objectKeys(subscriptions).length);">
			<!--Testing Cards-->
			<div class = "card" style="width: 18rem;box-shadow: 0px 15px 30px rgb(64,75,99,0.2) !important;border-radius: 25px;">
					<div  [ngStyle] = "getColor(subscription[1].url,subscription[1].logoExists)"class = "box">
					</div>

					<div style = "margin:0;text-align: initial;" class="card-body">
							<h5 class="card-title">{{subscription[1].name}}</h5>
							<p class = "text-muted">{{subscription[1].price}}  /{{subscription[1].payment_sched.slice(0,subscription[1].payment_sched.length-2)}}</p>
							<p class = "text-muted" style = "margin-top:-15px;">Next Bill: {{formattedDate(subscription[1].next_bill)}}</p>
							<button (click)="open(content,subscription[1],subscription[0])" class = "viewdetails-btn" >VIEW</button>
					</div>

					<ng-container *ngIf = "expiringSoon(subscription[1].next_bill) || subscription[1].status=='cancelled'">
							<div style = "width:50px;height:40px;position:absolute;top:-15px;right:25px;box-shadow: 0px 15px 30px rgb(64,75,99,0.2) !important;border-radius: 15px;display:flex;align-content: center;align-items: center;" class = "card">
								<ng-container *ngIf = "subscription[1].status=='cancelled'">
									<p style = "color:#f94040;font-size: 8px;text-align: center;font-weight: bold;margin-top:10px;">Cancelled</p>
								</ng-container>
								<ng-container *ngIf = "subscription[1].status!='cancelled'">
									<ng-container *ngIf = "subscriptionPlan == 'subscrybe-premium'">
											<p style = "color:#f94040;font-size: 9px;text-align: center;font-weight: bold;margin-top:5px;margin-bottom:0px;">Renews in</p> <p style = "color:#232323;font-size: 9px;text-align: center;font-weight: bold;">{{expiringSoon(subscription[1].next_bill)}}</p>
									</ng-container>
									<ng-container *ngIf = "subscriptionPlan != 'subscrybe-premium'">
											<p style = "color:#f94040;font-size: 9px;text-align: center;font-weight: bold;margin-top:5px;margin-bottom:0px;">Expiring Soon</p> 
									</ng-container>
								</ng-container>
							</div>
						</ng-container>
			</div>
			
			<!-- <div  class="card" style="width: 18rem;box-shadow: 0px 15px 30px rgb(64,75,99,0.2) !important;border-radius: 25px;">
					<div  [ngStyle] = "getColor(subscriptions[subscription].url,subscriptions[subscription].logoExists)"class = "box">
					</div>

					<div style = "margin:0;text-align: initial;" class="card-body">
					  <h5 class="card-title">{{subscriptions[subscription].name}}</h5>
					  <p class = "text-muted">{{subscriptions[subscription].price}}  /{{subscriptions[subscription].payment_sched.slice(0,subscriptions[subscription].payment_sched.length-2)}}</p>
					  <p class = "text-muted" style = "margin-top:-15px;">Next Bill: {{formattedDate(subscriptions[subscription].next_bill)}}</p>
					  <button (click)="open(content,subscriptions[subscription],subscription)" class = "viewdetails-btn" >VIEW</button>
					</div>

					<ng-container *ngIf = "expiringSoon(subscriptions[subscription].next_bill) || subscriptions[subscription].status=='cancelled'">
						<div style = "width:50px;height:40px;position:absolute;top:-15px;right:25px;box-shadow: 0px 15px 30px rgb(64,75,99,0.2) !important;border-radius: 15px;display:flex;align-content: center;align-items: center;" class = "card">
							<ng-container *ngIf = "subscriptions[subscription].status=='cancelled'">
								<p style = "color:#f94040;font-size: 8px;text-align: center;font-weight: bold;margin-top:10px;">Cancelled</p>
							</ng-container>
							<ng-container *ngIf = "subscriptions[subscription].status!='cancelled'">
								<p style = "color:#f94040;font-size: 9px;text-align: center;font-weight: bold;margin-top:5px;margin-bottom:0px;">Expiring Soon</p>
							</ng-container>
						</div>
					</ng-container>
			</div>			 -->
		</div>
</div>
</div>

<button id = "add-btn" style = "border-radius:25px;margin:3%;color:#6E1FD2;border-color:#6E1FD2;" class="btn btn-lg btn-outline-primary" (click)="openAdd(addSub)">+</button>

<div class = "cred">
<a href="https://clearbit.com">Logos provided by Clearbit</a>
</div>
